import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonToggleOption } from '../button-toggle/button-toggle.component';

@Component({
  selector: 'app-tab-toggle',
  templateUrl: './tab-toggle.component.html',
  styleUrls: ['./tab-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabToggleComponent {
  @Input() toggleOptions: ButtonToggleOption[] = [];
  @Input() selectedValue!: any;
  @Output() valueChanged = new EventEmitter<any>();

  public onSelect(value: any): void {
    this.valueChanged.emit(value);
  }
}
